import React from 'react'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { formatDateFields } from '../../helpers';
import { getPromoCodePaginated } from '../../api/promoCodeApi'
import SearchBar from '../SearchBar'
import DataTableBase from '../utils/DataTable';

class PromoCodeView extends React.Component {

    constructor(props) {
        let filterValue = '';
        super(props)

        this.state = {
            data: [],
            loading: true,
            value: '',
            create: false,
            edit: false,
            promoCode: null,
            onlyActive: false,
            customFilters: {
                showOnlyActiveFilter: true,
                onlyActiveFilterLabel: "Only show active promo code",
                onlyActiveOnChange: this.onlyActiveOnChange
            },
            value: filterValue,

            totalRows: 0,
            perPage: 10,
            orderBy: '',
            descending: false,
            defaultPage: 1
        }
        this.isSorting = false;
        this.onlyActiveOnChange = this.onlyActiveOnChange.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);

        this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
        this.fetchData('', 0, false);
    }

    onlyActiveOnChange = (e) => {
        let value = this.state.value;
        let isChecked = e.target.checked;
        if (isChecked) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                onlyActive: isChecked,
                page: 0,
                loading: true,
                value: value
            })
        } else if (!isChecked) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                onlyActive: isChecked,
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    filterSearch = event => {
        let value = event.target.value;
        let isChecked = this.state.onlyActive;
        if (event.key === 'Enter' && value) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                page: 0,
                loading: true,
                value: value
            })
        } else if (!value) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    fetchData = (filterValue, page, isChecked) => {
        let p = <p className="cursor closed" >
            <FontAwesomeIcon icon="bars" size="sm" color="#28A745" />
        </p>;
        if (typeof filterValue === 'object')
            filterValue = this.state.value;
        if (page === undefined) {
            page = this.state.defaultPage;
        }
        if (page !== 0)
            page = page - 1;
        if (isChecked === undefined)
            isChecked = this.state.onlyActive;
        this.setState({ loading: true, error: false });
        let orderBy = this.state.orderBy;
        let descending = this.state.descending;
        getPromoCodePaginated(filterValue, page, this.state.perPage, orderBy, descending, isChecked)
            .then((res) => {
                let moreOptions = [];
                for (let x = 0; x < res.data.data.results.length; x++) {
                    moreOptions.push(p)
                }
                this.setState({
                    page: res.data.data.currentPage,
                    data: res.data.data.results,
                    pages: res.data.data.pageCount,
                    totalRows: res.data.data.rowCount,
                    moreOptions: moreOptions,
                    loading: false
                })
            }).catch((err) => {
                let errorList = [];
                err.response.data.errors.map(function (e) { errorList.push(e.message) });

                this.setState({
                    data: [],
                    error: true,
                    loading: false,
                    errorMessage: errorList
                })
            });
    }

    handleEdit = (promoCode) => {
        this.setState({
            edit: true,
            promoCode: promoCode
        })
    }

    handleCreate = () => {
        this.setState({
            create: true
        })
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage }, () => {
            this.fetchData(this.state.value, page);
        });
    }

    handlePageChange(page) {
        if (this.isSorting) return;
        this.fetchData(this.state.value, page);
    }

    handleSort(column) {
        this.isSorting = true;
        this.setState({ descending: !this.state.descending, orderBy: column.sortField }, () => {
            this.fetchData(this.state.value);
            this.isSorting = false;
        });
    }

    render() {
        if (this.state.edit) {
            return <Redirect
                to={{
                    pathname: `/secure/promoCodeEdit/${this.state.promoCode.promoCodeId}`,
                }}
                push={true} />;
        }

        if (this.state.create) {
            return <Redirect
                to={{
                    pathname: `/secure/promoCodeCreate`,
                }}
                push={true} />;
        }

        const columns = [{
            name:
                <div
                    style={{
                        textIndent: 10,
                        textAlign: "left",
                    }}
                >
                    Promo code <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '200px',
            selector: row => row.promoCodeCode,
            sortable: true,
            sortField: 'promoCodeCode',
            cell: (row) => <div onClick={() => this.handleEdit(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.promoCodeCode}</p></div>
        }, {
            name:
                <div
                    style={{
                        textIndent: 0,
                        textAlign: "left",
                    }}
                >
                    Display name <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '270px',
            selector: row => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row) => <div onClick={() => this.handleEdit(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.name}</p></div>
        }, {
            name:
                <div
                    style={{
                        textAlign: "left",
                    }}
                >
                    Branch <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '250px',
            selector: row => row.branchName,
            sortable: true,
            sortField: 'branchName',
            cell: (row) => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.branchName}</p></div>
        }, {
            name:
                <div
                    style={{
                        textAlign: "left",
                    }}
                >
                    Start date <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '125px',
            selector: row => row.startDate,
            sortable: true,
            sortField: 'startDate',
            cell: (row) => <div onClick={() => this.handleEdit(row)}><p className="cursor">{formatDateFields(row.startDate)}</p></div>
        }, {
            name:
                <div
                    style={{
                        textAlign: "left",
                    }}
                >
                    Expiration date <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '125px',
            selector: row => row.endDate,
            sortable: true,
            sortField: 'endDate',
            cell: (row) => <div onClick={() => this.handleEdit(row)}><p className="cursor">{formatDateFields(row.endDate)}</p></div>
        }, {
            name:
                <div
                    style={{
                        textAlign: "left",
                    }}
                >
                    Code status <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '125px',
            selector: row => row.promoCodeStatus,
            sortable: true,
            sortField: 'promoCodeStatus',
            cell: (row) => <div><p style={{ marginLeft: 5 }} className="cursor">{row.promoCodeStatus}</p></div>
        }]

        return <div>
            <SearchBar
                onKeyUp={this.filterSearch}
                onClick={this.filterSearch}
                onChange={this.filterSearch}
                value={this.state.value}
                customFilters={this.state.customFilters}
            />

            <DataTableBase
                columns={columns}
                isLoading={this.state.loading}
                data={this.state.data}
                paginationTotalRows={this.state.totalRows}
                paginationPerPage={this.state.perPage}
                paginationDefaultPage={this.state.defaultPage}
                onChangeRowsPerPage={this.handlePerRowsChange}
                onChangePage={this.handlePageChange}
                onSort={this.handleSort}
            />

            <button onClick={() => this.handleCreate()} className="btn mt-4"> + PROMO CODE</button>
        </div>
    }
}

export default PromoCodeView